import { Star, Quote, MapPin, Calendar } from "lucide-react";

const UserReviews = () => {
  const reviews = [
    {
      id: 1,
      name: "김영희",
      age: 45,
      course: "해파랑길 7코스",
      date: "2025년 3월",
      rating: 5.0,
      title: "원하는 날짜에 예약할 수 있어서 정말 좋았어요!",
      content: "다른 여행사는 정해진 일정에 맞춰야 했는데, 홀씨는 제가 원하는 날짜에 예약할 수 있어서 너무 편했습니다. 리무진 버스도 정말 편안했고, 가이드분이 친절하게 설명해주셔서 트레킹이 더욱 즐거웠어요.",
      image: "/images/avatar1.jpg"
    },
    {
      id: 2,
      name: "박정수",
      age: 52,
      course: "남파랑길 15코스",
      date: "2025년 4월",
      rating: 4.8,
      title: "안전하고 편안한 최고의 트레킹 경험",
      content: "혼자서는 엄두가 안 났던 트레킹을 홀씨와 함께하니 정말 안전하고 편안했습니다. 전문 인솔자분이 계셔서 안심이 되었고, 같이 참여한 분들과도 좋은 추억을 만들었어요. 다음에도 꼭 이용하고 싶습니다.",
      image: "/images/avatar2.jpg"
    },
    {
      id: 3,
      name: "이민정",
      age: 38,
      course: "서해랑길 23코스",
      date: "2025년 5월",
      rating: 4.9,
      title: "가족과 함께한 소중한 시간",
      content: "아이들과 함께 할 수 있는 트레킹을 찾다가 홀씨를 알게 되었어요. 당일 투어라서 부담 없었고, 가이드분이 아이들을 세심하게 챙겨주셔서 감사했습니다. 리무진 버스에서 아이들이 너무 좋아했어요!",
      image: "/images/avatar3.jpg"
    },
    {
      id: 4,
      name: "최동훈",
      age: 29,
      course: "DMZ 평화의 길 3코스",
      date: "2025년 6월",
      rating: 4.7,
      title: "특별한 의미의 트레킹을 경험했어요",
      content: "DMZ 평화의 길은 정말 특별한 경험이었습니다. 역사적 의미도 깊고, 평소에 갈 수 없는 곳을 안전하게 다녀올 수 있어서 좋았어요. 홀씨만의 차별화된 서비스 덕분에 만족스러운 여행이었습니다.",
      image: "/images/avatar4.jpg"
    },
    {
      id: 5,
      name: "장혜진",
      age: 41,
      course: "해파랑길 12코스",
      date: "2025년 7월",
      rating: 4.6,
      title: "혼자여도 외롭지 않은 트레킹",
      content: "혼자 여행하기 좋은 프로그램을 찾다가 홀씨를 선택했는데 정말 잘한 것 같아요. 다른 참가자분들과 자연스럽게 어울릴 수 있었고, 전문 가이드분이 있어서 안전했습니다. 원하는 날짜에 예약할 수 있는 시스템이 최고예요!",
      image: "/images/avatar5.jpg"
    },
    {
      id: 6,
      name: "윤성호",
      age: 48,
      course: "남파랑길 8코스",
      date: "2025년 7월",
      rating: 4.5,
      title: "재참여하고 싶은 완벽한 서비스",
      content: "처음에는 반신반의했는데, 정말 만족스러운 경험이었습니다. 최소 인원이 모이면 출발한다는 시스템도 투명하고 좋았어요. 다음 달에 또 다른 코스로 예약했습니다. 홀씨와 함께라면 전국 둘레길을 다 다녀볼 수 있을 것 같아요!",
      image: "/images/avatar6.jpg"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <span>💬</span>
            <span>고객 후기</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            홀씨와 함께한 
            <span className="block text-[#F39800] mt-2">특별한 여행 이야기</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            실제 고객들이 경험한 홀씨만의 차별화된 서비스를 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div 
              key={review.id}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-100 relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#F39800]/20" />
              
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#F39800] to-[#E08700] rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-gray-800">{review.name}</h4>
                  <p className="text-sm text-gray-500">{review.age}세</p>
                </div>
              </div>

              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    className={`w-4 h-4 ${
                      i < Math.floor(review.rating) ? 'text-yellow-400 fill-current' : 
                      (i === Math.floor(review.rating) && review.rating % 1 !== 0) ? 'text-yellow-400 fill-current' : 
                      'text-gray-300'
                    }`} 
                  />
                ))}
                <span className="ml-2 text-sm text-gray-600">{review.rating}</span>
              </div>

              <h5 className="font-bold text-lg text-gray-800 mb-3 leading-tight">
                "{review.title}"
              </h5>

              <p className="text-gray-600 leading-relaxed mb-6">
                {review.content}
              </p>

              <div className="border-t border-gray-200 pt-4">
                <div className="flex items-center gap-4 text-sm text-gray-500">
                  <div className="flex items-center gap-1">
                    <MapPin className="w-4 h-4" />
                    <span>{review.course}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    <span>{review.date}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-[#F39800]/10 via-white to-[#F39800]/5 rounded-3xl p-8 shadow-lg border border-[#F39800]/20 max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              당신도 홀씨와 함께 특별한 추억을 만들어보세요!
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              원하는 날짜에, 원하는 코스로 떠나는 프리미엄 트레킹 경험이 기다리고 있습니다.
            </p>
            <div className="flex flex-wrap gap-6 justify-center text-sm">
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Star className="w-4 h-4 fill-current" />
                <span>평균 만족도 4.7점</span>
              </div>
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Quote className="w-4 h-4" />
                <span>실제 고객 후기</span>
              </div>
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Calendar className="w-4 h-4" />
                <span>원하는 날짜 예약 가능</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserReviews;